<template>
  <admin-wrapper
    title-translation-path="admin.SEND_MESSAGE_MODULE"
    :module-enabler="moduleEnabler"
    :has-buttons="false"
  />
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';

export default {
  name: 'SendMessageSettings',
  components: {
    AdminWrapper,
  },
  computed: {
    moduleEnabler() {
      return {
        name: 'send_message_module_enabled',
        translationPath: 'admin.SEND_MESSAGE_MODULE',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.SEND_MESSAGE_MODULE') }),
      };
    },
  },
};
</script>
